import {
  type CreateFolderParams,
  type DeleteFolderParams,
  type RenameFolderParams,
  folderSchema,
} from '@/types/folder';
import { INTERNAL_V1, damRequest } from '@/hooks/damRequest';
import { auditDefaultPageSize } from '@/types/pagination';
import { getAssetsRootSchema } from '@/types/asset';
import { getAuditsSchema } from '@/types/audit';

const getFolder = async (params?: string, token?: string) => {
  const response = await damRequest('GET', `${INTERNAL_V1}/folders/${params}`, token, {});
  return folderSchema.parse(response);
};

const createFolder = async (params?: CreateFolderParams, token?: string) => {
  const response = await damRequest('POST', `${INTERNAL_V1}/folders`, token, {
    body: params,
  });

  return folderSchema.parse(response);
};

const renameFolder = async (
  { id, name, description, slug }: RenameFolderParams & { id?: string | null },
  token?: string,
) => {
  const response = await damRequest('PATCH', `${INTERNAL_V1}/folders/${id}`, token, {
    body: { name, description, slug },
  });

  return folderSchema.parse(response);
};

const deleteFolder = async (params?: DeleteFolderParams, token?: string) => {
  const response = await damRequest('DELETE', `${INTERNAL_V1}/folders/${params?.id}`, token);
  return folderSchema.parse(response);
};

const unDeleteFolder = async (params?: DeleteFolderParams, token?: string) => {
  const response = await damRequest('POST', `${INTERNAL_V1}/folders/${params?.id}/undelete`, token, {});
  return folderSchema.parse(response);
};

const getFolderAuditLog = async (
  params?: { id?: string; pagination?: { offset: number; limit: number } },
  token?: string,
) => {
  const query = new URLSearchParams({
    offset: String(params?.pagination?.offset ?? 0),
    limit: String(params?.pagination?.limit ?? auditDefaultPageSize),
  }).toString();

  const response = await damRequest('GET', `${INTERNAL_V1}/folders/${params?.id}/audit?${query}`, token);
  return getAuditsSchema.parse(response);
};

const getFolderWithAncestors = async (params: { folderId: string }, token?: string) => {
  const query = new URLSearchParams({
    offset: '0',
    limit: '1',
    includeAssets: '0',
  }).toString();

  const response = await damRequest('GET', `${INTERNAL_V1}/folders/${params.folderId}?${query}`, token, {});
  return getAssetsRootSchema.parse(response);
};

export {
  getFolder,
  createFolder,
  deleteFolder,
  unDeleteFolder,
  renameFolder,
  getFolderAuditLog,
  getFolderWithAncestors,
};
